import { LoginPageController } from "./LoginPage.controller"
import { ClasscodeLogin } from "./login/ClasscodeLogin"

import scribsBackground from "../../assets/images/scribs.png"
import classkickLogo from "../../assets/images/brand/classkick-logo-all-white-small.png"

interface LoginPageProps {
  controller: LoginPageController
}

export function LoginPage({ controller }: LoginPageProps) {
  const backgroundStyle = {
    backgroundImage: `url(${scribsBackground})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    transform:
      "scale(0.625)" /* Legacy Refactor: scaling up due to html font-size of 10px in classkick.scss */,
    transformOrigin: "top left",
    backgroundColor: "#25c582",
  }

  return (
    <div
      className="tw-min-h-screen tw-w-screen tw-flex tw-flex-col tw-items-center"
      style={backgroundStyle}
    >
      <a href="https://www.classkick.com" className="tw-mt-24 tw-mb-10">
        <img
          src={classkickLogo}
          alt="Classkick Logo"
          className="tw-w-[16rem]"
        />
      </a>
      <ClasscodeLogin controller={controller} />
    </div>
  )
}
